import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    CardContent,
    Card as MuiCard,
    Typography,
    Chip,
    IconButton,
    Avatar,
} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import PeopleIcon from '@material-ui/icons/People';
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import { FileText } from "react-feather";
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { useDispatch, useSelector } from "react-redux";
import { AppStateType } from "../../../../redux/reducers";
import { fetchUser } from "../../../../redux/actions/userActions";
import { fetchCompany } from "../../../../redux/actions/companyActions";
import { useHistory } from "react-router-dom";
const Card = styled(MuiCard)(spacing);

const CardRoot = styled(Card)`
    background: linear-gradient(to top, #233145 0%, #233145 80%, #303c4c 80%, #303c4c 100%);
`;
const CardIconContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-end;
`;
const TypeChip = styled(Chip)`
    margin-top: 10px;
    border-radius: 50px;
    margin-bottom: 10px;
    text-transform: capitalize;
    height: auto;
    padding: 2px;
    .MuiChip-label {
        padding-left: 8px;
        padding-right: 8px;
    }
`

export const standardTypeOptions: any = {
    hotel: "Hotel",
    hotel_motel: "Hotel/Motel",
    office: "Office",
    shopping_mall: "Shopping mall",
    shop: "Shop",
    restaurant: "Restaurant",
    museum: "Museum",
    arena: "Arena",
    indoor_playground: "Indoor playground",
    outdoor_playground: "Outdoor playground",
}

export function CompanyCard() {

    const company: any = useSelector((state: AppStateType) => state.companyReducer.company);

    const history = useHistory();
    const { t } = useTranslation();
    const user: any = useSelector((state: AppStateType) => state.authReducer.user)
    const userProfile: any = useSelector((state: AppStateType) => state.userReducer.user)

    const dispatch = useDispatch()
    useEffect(() => {
        if (user) {
            dispatch(fetchUser(user.user, user.token))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        if (userProfile && userProfile.company) {
            dispatch(fetchCompany(userProfile.company, user.token))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userProfile])

    if (!company) {
        return <div />;
    }

    const renderStandardTypes = (standards: string[]) => {
        if (!standards.length) {
            return
        }
        const standardsNames = standards.map((item, index) => {
            return (
                <li key={index} style={{margin: "6px 0"}}>
                    {standardTypeOptions[item]}
                </li>
            )
        })
        return (
            <>
                <div style={{ display: "flex", alignItems: "center", fontSize: "25px"}}>
                    <FileText style={{
                        color: "#C4C4C4",
                        marginRight: "10px",
                    }} />
                    <Typography style={{fontWeight: 500}}>
                        {t("companyCard_supportedStandards")}
                    </Typography>
                </div>
                <ul style={{listStyle: 'inside', marginLeft: 35}}>
                    {standardsNames}
                </ul>
            </>
        )
    }

    return <CardRoot mb={6} >
        <CardContent>
            <CardIconContainer>
                <IconButton onClick={() => history.push("/settings")}>
                    <EditIcon />
                </IconButton>
            </CardIconContainer>
            <Avatar variant="rounded" alt="company" src={company.thumbnails.small} style={{
                width: "120px",
                height: "120px",
                marginTop: "-15px",
            }} />
            <Typography style={{ marginTop: "15px" }} variant="h4" gutterBottom>
                {company.name}
            </Typography>
            <TypeChip label={company.type} />
            <div style={{
                marginBottom: "10px"
            }}>
                <Typography style={{fontWeight: '500', marginBottom: "5px"}}>
                    {t("companyCard_companyInformation")}
                </Typography>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                }}>
                    <LocationOnIcon style={{
                        color: "#C4C4C4",
                        marginRight: "10px",
                        fontSize: "25px"
                    }} />
                    {company?.address?.address_line_1}
                </div>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "5px 0"
                }}>
                    <PeopleIcon style={{
                        color: "#C4C4C4",
                        marginRight: "10px",
                        fontSize: "25px"
                    }} />
                    {company.nr_employees} {t("companyCard_numberOfEmployees")}
                </div>
                {renderStandardTypes(company.supported_a11y_standards)}
            </div>
            {/* <DisabledMessageWrapper disabled={true} disableMessage="Accessibility Classification Still Not Available">
                <Grid container spacing={6}>
                    <Grid item xs={12} >
                        <List style={{
                            background: "#FFFFFF",
                            color: "black",
                            borderRadius: "10px",
                        }}>
                            {generate(
                                <ListItem>
                                    <ListItemIcon>
                                        <FolderIcon color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        style={{
                                            color: "black",
                                        }}
                                        primary="Mobility"
                                        secondary={"Maecenas tempus, tellus eget"}
                                        secondaryTypographyProps={{
                                            style: {
                                                color: "gray"
                                            }
                                        }}
                                    />
                                </ListItem>,
                            )}
                        </List>
                    </Grid>
                </Grid>
            </DisabledMessageWrapper> */}
        </CardContent>
    </CardRoot>;
}